import React, { FC } from 'react';
import styles from './AppFooter.module.scss';
import BackgroundBar from '../styled/BackgroundBar';
import {
  PAMBeaconFooter,
  PAMBeaconNavigationfooter,
  PAMBeaconSocialLink,
  PAMBeaconSocialLinkContainer
} from '../../utils/beacon';
import { FOOTER_LINKS } from '../../utils/constants';

type Props = {
  urls: ConfigUrls;
};

const copyright = `\u00A9 ${new Date().getFullYear()}.`;

const AppFooter: FC<Props> = ({ urls }) => (
  <div>
    <footer className={styles['footer-background']}>
      <BackgroundBar className={styles['footer-disclaimer']}>
        <p className={styles['footer-header']}>Definitions</p>
        <p>Capital Change equals contributions minus withdrawals.</p>
        <p>
          Capital Investment is the total of the initial client investment and
          capital changes.
        </p>
        <p>
          Estimated Annual Income is a projection of future dividend and
          interest payments expected to be received over the next twelve months
          on investments held and may be higher or lower than actual income
          received during the period. Generally, for equities, estimated annual
          income is calculated based upon the most recent dividend paid times
          the frequency of payment. For mutual funds, estimated annual income is
          based upon the previous 12-month distribution payments. For securities
          that could include a return of principal or capital gains, Estimated
          Annual Income could be overstated.
        </p>
        <p>
          Estimated Yield at Market is calculated by multiplying the number of
          shares/units held by the income rate and dividing by the Market Value.
          Estimated Yield reflects only the income generated and does not
          consider changes in the security’s price, which may fluctuate. Actual
          portfolio yield may be higher or lower than what was estimated.
        </p>
        <p className={styles['footer-header']}>Additional Disclosures</p>
        <p>
          Market values include accrued income where applicable. Your Investment
          Advisory Account information displayed is not reconciled to your
          custodian on a daily basis. In addition, transactions regarding T.
          Rowe Price Mutual Funds that are held in your account are reported on
          a one day delay. Therefore, daily information (including portfolio
          holdings and cash balances) may not be accurate.
        </p>
        <p>Amortized cost will be reflected where applicable.</p>
        <p>
          Note: T. Rowe Price strongly encourages you to reconcile this
          statement to the statements you receive directly from your custodian,
          broker, or the Price Funds, as applicable, to ensure consistency. If
          you have any questions with respect to this statement, please contact
          your T. Rowe Price Portfolio Manager.
        </p>
      </BackgroundBar>
    </footer>

    <div className="beacon-theme-modern-outlook beacon-on-darker">
      <PAMBeaconFooter>
        <div slot="trademark">
          Invest With Confidence<sup>®</sup>
        </div>
        <blockquote slot="mission">
          Our mission is simple, to help clients around the world achieve their
          long term investment goals.
        </blockquote>
        <PAMBeaconNavigationfooter slot="links">
          <span slot="title">Privacy & Legal</span>

          <a href={FOOTER_LINKS.siteMapUrl}>Site Map</a>

          <a href={FOOTER_LINKS.privacyPolicyUrl}>Privacy Policy</a>

          <a href={FOOTER_LINKS.termsOfUseUrl}>Terms of Use</a>

          <a href={FOOTER_LINKS.legalInformationUrl}>Legal Information</a>
        </PAMBeaconNavigationfooter>

        <PAMBeaconSocialLinkContainer slot="socials">
          <p slot="text">Find us on:</p>
          <PAMBeaconSocialLink>
            <a href="https://facebook.com">Facebook</a>
          </PAMBeaconSocialLink>
          <PAMBeaconSocialLink>
            <a href="https://instagram.com">Instagram</a>
          </PAMBeaconSocialLink>
          <PAMBeaconSocialLink>
            <a href="https://linkedin.com">LinkedIn</a>
          </PAMBeaconSocialLink>
          <PAMBeaconSocialLink>
            <a href="https://x.com">X</a>
          </PAMBeaconSocialLink>
          <PAMBeaconSocialLink>
            <a href="https://youtube.com">YouTube</a>
          </PAMBeaconSocialLink>
        </PAMBeaconSocialLinkContainer>
        <div slot="disclaimer">
          <p>
            The funds referred to in this website are offered and sold only to
            persons residing in the United States and are offered by prospectus
            only. The prospectuses include investment objectives, risks, fees,
            expenses, and other information that you should read and consider
            carefully before investing.
          </p>
          <p>
            Download a{' '}
            <a href={FOOTER_LINKS.mutualFundProspectus}>
              mutual fund prospectus
            </a>{' '}
            or <a href={FOOTER_LINKS.ETFProspectus}>ETF prospectus</a>.
          </p>
        </div>
        <div slot="copyright">
          <p>
            {copyright} All Rights Reserved. T. Rowe Price Investment Services,
            Inc., distributor, T. Rowe Price mutual funds and T. Rowe Price
            ETFs. T. ROWE PRICE, INVEST WITH CONFIDENCE, and the bighorn sheep
            design are trademarks of T. ROWE PRICE Group, Inc. All other
            trademarks are the property of their respective owners.
          </p>
        </div>
      </PAMBeaconFooter>
    </div>
  </div>
);

export default AppFooter;
